import { apiProvider } from './api';
import { NAME as name } from './constants';
import { router } from './router';

export const Edl = {
	name,
	apiProvider,
	router,
};
